import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/auth.service';
import Logo from './../assets/weinberger_logo_black.svg';

export default function Header() {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = React.useState(false);
  const isHausverwaltung = AuthService.isHausverwaltung();

  const openNav = (open) => () => setNavOpen(open);

  const navigateToDashboard = (e) => { e?.preventDefault?.(); navigate('/dashboard'); };
  const navigateToAnleitungen = () => navigate('/anleitungen');
  const navigateToReklamation = () => navigate('/warranty');
  const navigateToHausverwaltungReklamation = () => navigate('/HausverwaltungReklamation');
  const handleLogout = () => { AuthService.logout(); navigate('/login'); };

  const NavLinks = (
    <>
      <Button color="primary" onClick={navigateToDashboard}>Übersicht</Button>
      <Button color="primary" onClick={navigateToAnleitungen}>Allgemeine Anleitungen</Button>
      <Button color="primary" onClick={navigateToReklamation}>Reklamation erfassen</Button>
      {isHausverwaltung && (
        <Button color="primary" onClick={navigateToHausverwaltungReklamation}>Hausverwaltung Reklamation</Button>
      )}
    </>
  );

  return (
    <Box sx={{ flexGrow: 1, minHeight: 64, overflowX: 'hidden' }}>
      <AppBar 
        position="fixed" 
        sx={{ 
          backgroundColor: 'white', 
          py: 1, 
          boxShadow: 'none', 
          borderBottom: '1px solid #E7EBF0',
          width: '100%',
          overflowX: 'hidden'
        }}
      >
        <Container 
          maxWidth="xl" 
          sx={{ px: { xs: 2, sm: 3 }, overflowX: 'hidden' }}
        >
          <Toolbar sx={{ position: 'relative', px: 0, minHeight: 64, width: '100%' }}>
            {/* XS/SM: Burger links */}
            <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
              <IconButton onClick={openNav(true)} aria-label="Menü öffnen">
                <MenuIcon />
              </IconButton>
            </Box>

            {/* Logo: auf XS/SM zentriert, auf MD+ links */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                position: { xs: 'absolute', md: 'static' },
                left: { xs: '50%', md: 'auto' },
                transform: { xs: 'translateX(-50%)', md: 'none' },
              }}
            >
              <img
                src={Logo}
                alt="Logo"
                onClick={navigateToDashboard}
                style={{ cursor: 'pointer', height: 40 }}
              />
            </Box>

            {/* MD+: Links mittig */}
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                gap: 2,
              }}
            >
              {NavLinks}
            </Box>

            {/* Rechts: Logout-Icon */}
            <Box sx={{ ml: 'auto' }}>
              <Tooltip title="Logout">
                <IconButton color="primary" edge="end" aria-label="Logout" onClick={handleLogout}>
                  <LogoutIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Drawer für XS/SM */}
      <Drawer anchor="left" open={navOpen} onClose={openNav(false)}>
        <Box
          role="presentation"
          sx={{ width: 280, p: 1 }}
          onClick={openNav(false)}
          onKeyDown={openNav(false)}
        >
          <List>
            <ListItemButton onClick={navigateToDashboard}>
              <ListItemText primary="Übersicht" />
            </ListItemButton>
            <ListItemButton onClick={navigateToAnleitungen}>
              <ListItemText primary="Allgemeine Anleitungen" />
            </ListItemButton>
            <ListItemButton onClick={navigateToReklamation}>
              <ListItemText primary="Reklamation erfassen" />
            </ListItemButton>
            {isHausverwaltung && (
              <ListItemButton onClick={navigateToHausverwaltungReklamation}>
                <ListItemText primary="Hausverwaltung Reklamation" />
              </ListItemButton>
            )}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
}